module.exports = __webpack_public_path__ + "static/media/25.78776899.png";